function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? n(exports) : "function" == typeof define && define.amd ? define(["exports"], n) : n(e.I18nHelper = {});
}(this, function (e) {
  "use strict";

  var n = function n() {
    var e = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : "react";
    return function (n) {
      return function (t) {
        var r = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        if (!I18n) return r.defaultValue ? r.defaultValue : "";
        var o = e + "." + n;
        return t && (o += "." + t), I18n.t(o, r);
      };
    };
  };

  e.manageTranslations = n, e.actionsTranslation = function (e) {
    return n()("action_btns")("add", {
      type: n()(e)("title")
    });
  }, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});